import React from 'react';
import ReactDOM from 'react-dom';
import Store from "./state/store";
import Restore from "./state/restore";
import App from './App';
import reportWebVitals from './reportWebVitals';
import './assets/main.scss';

// @use './assets/main.scss';

ReactDOM.render(
  <React.StrictMode>
    <Store>
      <Restore>
        <App />
      </Restore>
    </Store>
  </React.StrictMode>,
  document.getElementById("root")
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
